var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-client-only", [
    _c(
      "div",
      { staticClass: "no-delivery-warning" },
      [
        _vm.isShow
          ? [
              _vm._v(
                "\n      По вашему запросу нет товаров доступных для оформления заказа.\n      Возможно они скоро появятся или временно недоступна "
              ),
              _c(
                "a",
                {
                  staticClass: "link-blue",
                  attrs: { href: "/delivery", target: "_blank" }
                },
                [_vm._v("доставка")]
              ),
              _vm._v(" в ваш регион.\n      Попробуйте "),
              _c(
                "span",
                {
                  ref: "changeRegion",
                  staticClass: "link-blue",
                  on: { click: _vm.changeRegion }
                },
                [_vm._v("изменить регион доставки")]
              ),
              _vm._v(
                " или проверьте наличие товаров в других категориях.\n    "
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }